var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu1-container"},[_c('el-alert',{attrs:{"closable":false,"title":"嵌套路由 1","type":"success"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }